// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Deposit (Funds Management) */
.deposits-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.deposits-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.deposits-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.deposits-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.deposits-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.deposits-section__stats {
  display: flex;
  gap: 1.25rem;
}

.deposits-section__stats--actions {
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.deposits-export-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(22, 101, 52, 0.35);
  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);
  color: #166534;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, box-shadow 0.2s;
}

.deposits-export-btn:hover:not(:disabled) {
  background: #dcfce7;
  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);
}

.deposits-export-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.deposits-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  flex: 0 1 120px;
}

.deposits-page-limit__select {
  max-width: none;
  margin: 0;
  min-width: 100px;
}

.deposits-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.deposits-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.deposits-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.deposits-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.deposits-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 360px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.deposits-search-input::placeholder {
  color: var(--text-muted);
}

.deposits-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.deposits-table-wrap {
  overflow-x: auto;
}

.deposits-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.deposits-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.deposits-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.deposits-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.deposits-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.deposits-table tbody tr:hover {
  background: #f0fdfa !important;
}

.deposits-table tbody tr:last-child td {
  border-bottom: none;
}

.deposits-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.deposits-hash {
  font-family: ui-monospace, monospace;
  font-size: 0.78rem;
  color: #475569;
  cursor: default;
}

.deposits-status {
  display: inline-block;
  padding: 0.3rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
}

.deposits-status--success {
  background: #dcfce7;
  color: #166534;
}

.deposits-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.deposits-status--failed {
  background: #fef2f2;
  color: #b91c1c;
}

.deposits-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Funds/FundsDepositPage.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX","sourcesContent":["/* Deposit (Funds Management) */\n.deposits-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.deposits-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.deposits-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.deposits-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.deposits-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.deposits-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.deposits-section__stats--actions {\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.deposits-export-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(22, 101, 52, 0.35);\n  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);\n  color: #166534;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  transition: background 0.2s, box-shadow 0.2s;\n}\n\n.deposits-export-btn:hover:not(:disabled) {\n  background: #dcfce7;\n  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);\n}\n\n.deposits-export-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.deposits-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  flex: 0 1 120px;\n}\n\n.deposits-page-limit__select {\n  max-width: none;\n  margin: 0;\n  min-width: 100px;\n}\n\n.deposits-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.deposits-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.deposits-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.deposits-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.deposits-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 360px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.deposits-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.deposits-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.deposits-table-wrap {\n  overflow-x: auto;\n}\n\n.deposits-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.deposits-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.deposits-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.deposits-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.deposits-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.deposits-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.deposits-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.deposits-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.deposits-hash {\n  font-family: ui-monospace, monospace;\n  font-size: 0.78rem;\n  color: #475569;\n  cursor: default;\n}\n\n.deposits-status {\n  display: inline-block;\n  padding: 0.3rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.deposits-status--success {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.deposits-status--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.deposits-status--failed {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.deposits-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
